// Utils
//import { isDefined } from '../../shared/utils/is';
import { CSS_TO_CATEGORY_MAP } from '../constants';


function compareFunctionForProjects(categoryA, categoryB) {
  const projectA = categoryA.project;
  const projectB = categoryB.project;

  if (projectA < projectB) {
    return -1;
  }

  if (projectA > projectB) {
    return 1;
  }

  return 0;
}

export function groupCategoriesByProject(projectCategories, zoneId) {
  const cleanedProjectCategories = projectCategories.filter(
    pC => !pC.isDeleted && pC.zoneId === zoneId
  );
  // .map(projectCategory => {
  //   return {
  //     ...projectCategory,
  //     project: isDefined(projectCategory.project) ? projectCategory.project.trim() : ''
  //   };
  // });
  const sortedProjectCategories = cleanedProjectCategories.sort(compareFunctionForProjects);

  const projects = [];
  let currentProject = { projectName: '', categories: [] };

  for (const category of sortedProjectCategories) {
    if (currentProject.projectName !== category.project) {
      currentProject = { projectName: category.project, categories: [ category ] };
      projects.push(currentProject);
    } else {
      currentProject.categories.push(category);
    }
  }

  return projects;
}

export const extractProjectCategoryFromCSS = (mapLayersByProjCatTree, cssFileName) => {
  const category = CSS_TO_CATEGORY_MAP[cssFileName];

  if (category) {
    const project = Object.keys(mapLayersByProjCatTree).find(
      projectName => !!mapLayersByProjCatTree[projectName][category]
    );

    if (project) {
      const layerIds = Object.values(mapLayersByProjCatTree[project][category])
        .reduce(
          (ids, layer) => `${ids}${ids ? ',' : ''}${layer.id}`,
          ''
        );

      return { cssFileName, project, category, layerIds };
    }
  }

  return undefined;
};
